// services/authService.js
import api from './api';

/**
 * Сервис для работы с аутентификацией
 */
const authService = {
  /**
   * Вход пользователя в систему
   * @param {string} username - Имя пользователя
   * @param {string} password - Пароль
   * @returns {Promise<Object>} - Данные пользователя и токены
   */
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    
    // Сохраняем токены в localStorage
    localStorage.setItem('accessToken', response.data.accessToken);
    localStorage.setItem('refreshToken', response.data.refreshToken);
    
    return response.data;
  },

  /**
   * Выход пользователя из системы
   * @returns {Promise<void>}
   */
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Ошибка при выходе из системы:', error);
    } finally {
      // Удаляем токены из localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  },

  /**
   * Обновление токена доступа
   * @param {string} refreshToken - Токен обновления
   * @returns {Promise<Object>} - Новые токены
   */
  refreshToken: async (refreshToken) => {
    const response = await api.post('/auth/refresh-token', { refreshToken });
    
    // Сохраняем новые токены в localStorage
    localStorage.setItem('accessToken', response.data.accessToken);
    localStorage.setItem('refreshToken', response.data.refreshToken);
    
    return response.data;
  },

  /**
   * Получение профиля текущего пользователя
   * @returns {Promise<Object>} - Данные пользователя
   */
  getUserProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  /**
   * Смена пароля пользователя
   * @param {string} currentPassword - Текущий пароль
   * @param {string} newPassword - Новый пароль
   * @param {string} confirmNewPassword - Подтверждение нового пароля
   * @returns {Promise<Object>} - Результат операции
   */
  changePassword: async (currentPassword, newPassword, confirmNewPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
      confirmNewPassword
    });
    
    return response.data;
  },

  /**
   * Проверка, аутентифицирован ли пользователь
   * @returns {boolean} - Результат проверки
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  },
};

export default authService;